import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { ValidatePatternDirective } from '@df/ui/form/validate-pattern.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { InputWrapBodyDirective } from '../input-wrap-body.directive';
import { InputWrapComponent } from '../input-wrap.component';
import { LocalAddressFieldsetComponentDef } from '../local-address-fieldset-def.component';
import { MuiInputDirective } from '../mui-input.directive';
import { ToggleComponent } from '../toggle/toggle.component';

@Component({
    selector: 'custom-form-pca-predict',
    templateUrl: './custom-form-pca-predict.html',
    styleUrl: './custom-form-pca-predict.scss',
    standalone: true,
    imports: [
        FormsModule,
        InputWrapBodyDirective,
        InputWrapComponent,
        MuiInputDirective,
        NgClass,
        OffClickDirective,
        OrderByPipe,
        ToggleComponent,
        TranslatePipe,
        ValidatePatternDirective
    ],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CustomFormPcaPredictComponent extends LocalAddressFieldsetComponentDef {}
